export const AUTHORIZED_SPORTS = ['nfl', 'pga']
export const AUTHORIZED_PARTNERS = ['ftn', 'ck', 'ftn-new', 'ftn_new', 'ows', '4for4']

export const SIMS_INACTIVE = false
export const SHOWDOWN_SIMS_INACTIVE = false
